package editor.capture

import pdflib.RGB
import pdflib.rgb

enum class CaptureBackground(val friendlyName: String, val color: RGB, val accentColor: RGB) {
    Orange("Orange", rgb(0.937, 0.722, 0.396), rgb(0.98, 0.95, 0.85)),
    Blue("Blau", rgb(0.192, 0.439, 0.706), rgb(0.5, 0.85, 0.98)),
    Green("Grün", rgb(0.353, 0.576, 0.565), rgb(0.6, 0.8, 0.75)),
}